import axios from '../../http'
import {API} from "../../const"

const api = API+'/shipping-address/enabled';

const error = (name) => (e) => console.error(name + ':=>', e);

export default function getShippingAddress(cb, fcb = error('getShippingAddress')) {
  axios.get(api).then(response => {
    response.data.region = response.data.region.replace(/-/g, ' ');
    cb(response.data);
  }).catch(response => {
    fcb(response);
  })
}